import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import LandingPage from "./components/LandingPage/LandingPage";
import TechnologyPage from "./components/Technology/TechnologyPage";
import ArticlesPage from "./components/Articles/ArticlesPage";
import ArticleDetailPage from "./components/Articles/ArticleDetailPage";
import HomePage from "./components/Home/HomePage";
import AboutUsPage from "./components/AboutUs/AboutUsPage";
import PrivacyPolicyPage from "./components/PrivacyPolicy/PrivacyPolicyPage";
import CopyrightNoticePage from "./components/CopyrightNotice/CopyrightNoticePage";
import LearnMorePage from "./components/Technology/LearnMorePage";
import GrowthTechnologyPage from "./components/Technology/GrowthTechnologyPage";
import BibleStudyResourcesPage from "./components/Resources/BibleStudyResourcesPage";
import AdminPage from "./components/Admin/AdminPage";
import AdminRegisterPage from "./components/Admin/AdminRegisterPage";

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/software" element={<LandingPage />} />
          <Route path="/technology" element={<TechnologyPage />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/articles/:articleId" element={<ArticleDetailPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/copyright-notice" element={<CopyrightNoticePage />} />
          <Route path="/learn-more-about-our-technology" element={<LearnMorePage />} />
          <Route path="/growth-profile-ai-technology" element={<GrowthTechnologyPage />} />
          <Route path="/bible-and-study-resources" element={<BibleStudyResourcesPage />} />
          <Route path="/resources" element={<BibleStudyResourcesPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/register" element={<AdminRegisterPage />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
};

export default App;
